import { render, staticRenderFns } from "./attachments.vue?vue&type=template&id=7fb0d9a5&"
import script from "./attachments.vue?vue&type=script&lang=js&"
export * from "./attachments.vue?vue&type=script&lang=js&"
import style0 from "./attachments.vue?vue&type=style&index=0&id=7fb0d9a5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports